/* eslint-disable react/prop-types */
import React from "react";

import "react-quill/dist/quill.snow.css";

import { useParams } from "react-router-dom";
import { swapService } from "services/swapService";

const Item = ({ label, value }) => {
  return (
    <div style={{ display: "flex", gap: 20, width: "100%" }}>
      <div style={{ width: 70, height: 70 }}>
        <span style={{ minWidth: 200, display: "block", fontWeight: 600 }}>
          {label}
        </span>
      </div>
      <div style={{ width: "100%", marginLeft: 70 }}>
        <span>{value}</span>
      </div>
    </div>
  );
};

const Text = ({ label, value, lastChild }) => {
  return (
    <>
      <span>
        <strong style={{ marginRight: 10 }}>{label}</strong>
        {value}
      </span>
      {!lastChild && <br />}
    </>
  );
};

export default function SwapView() {
  const [nft, setNft] = React.useState({});
  const { id } = useParams();

  async function fetchSwap(id) {
    const { data } = await swapService.view(id);
    setNft(data);
    console.log(nft);
  }

  React.useEffect(() => {
    fetchSwap(id);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        fontSize: 22,
      }}
    >
      <Item label="Swap ID:" value={nft.swapId} />
      <Item label="Hash:" value={nft.hash} />
      <Item label="Finished:" value={nft.finished ? "Yes" : "No"} />
      <Item label="Public:" value={nft.isPublic ? "Yes" : "No"} />
      <Item label=" User address:" value={nft?.user?.address} />

      <span
        style={{
          minWidth: 200,
          display: "block",
          fontWeight: 600,
          marginBottom: 20,
        }}
      >
        List nft:
      </span>

      {nft.items &&
        nft.items.length > 0 &&
        nft.items.map((item) => {
          return (
            <>
              {item.type !== "currency" && (
                <div
                  key={item._id}
                  style={{
                    display: "flex",
                    gap: 20,
                    alignItems: "center",
                    borderBottom: "1px solid black",
                    padding: "10px 0px",
                  }}
                >
                  <div style={{ width: 150, height: "100%" }}>
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 10,
                        objectFit: "cover",
                      }}
                      src={item.value.image}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: 60,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Text label="Token ID:" value={item.value.tokenId} />
                    <Text label="Name:" value={item.value.name} />
                    <Text label="Symbol:" value={item.value.symbol} />
                    <Text
                      label=" Token address:"
                      value={item.value.tokenAddress}
                      lastChild
                    />
                  </div>
                </div>
              )}
            </>
          );
        })}
    </div>
  );
}
